import { InfoCircle } from 'iconoir-react';
import { useTranslation } from 'react-i18next';
import { Alert, AlertDescription } from 'components/ui/alert';

/** Shown instead of a limit warning while top-up credits keep the organization working. */
export const TopUpCoverNote = () => {
  const { t } = useTranslation();

  return (
    <Alert role="status">
      <InfoCircle aria-hidden="true" className="h-4 w-4" />
      <AlertDescription>
        {t('PLAN_LIMIT_TOP_UP_COVERS', {
          defaultValue:
            "Your plan limit is reached. Usage now runs on your organization's top-up credits.",
        })}
      </AlertDescription>
    </Alert>
  );
};
